import React from 'react'

import { IconBase } from '../IconBase'
import { IconProps } from '../types'

export const X: React.FC<IconProps> = (props) => (
  <IconBase {...props}>
    <path
      d="M17 7L7 17M7 7L17 17"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </IconBase>
)
